// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 689 ? "b536a0f1" : chunkId) + "." + {"64":"f3bc05abeda9839f","173":"e945c439051340b5","494":"772fc17d00c3c66b","496":"f2628474ef2ee2fc","689":"e01b30d73ed6b055","929":"f7a3b81f8fe4f246"}[chunkId] + ".js";
};